<mat-card class="events-card">
  <mat-card-header>
    <mat-card-title>Eventos</mat-card-title>
  </mat-card-header>

  <mat-card-content class="events-card-content">

    <div *ngIf="events && events.length > 0; else noEvents" class="events-container">

      <div class="event-row header-row">
        <span class="minute">Tiempo</span>
        <span class="icon"></span>
        <span class="description">Descripción</span>
        <span class="score"></span>
      </div>

      <div *ngFor="let event of events" class="event-row">

        <span class="minute">
          {{ event.minute }}:{{ event.second | number: '2.0-0' }}
        </span>

        <span class="icon">
          <mat-icon [style.color]="getColorForEvent(event.event_type)">
            {{ getIconForEvent(event.event_type) }}
          </mat-icon>
        </span>

        <span class="description">
          <span class="event-type-label">{{ formatEventType(event.event_type) }}</span>
          <span *ngIf="event.player_name" class="event-actor">- {{ event.player_name }}</span>
          <span *ngIf="!event.player_name && event.team_name" class="event-actor">- {{ event.team_name }}</span>
        </span>

        <span class="score">
          <ng-container *ngIf="event.home_score != null && event.away_score != null">
            {{ event.home_score }} - {{ event.away_score }}
          </ng-container>
        </span>
      </div>
    </div>

    <ng-template #noEvents>
      <div class="no-events-container">
        <mat-icon>format_list_bulleted</mat-icon>
        <span>No hay eventos disponibles para este partido.</span>
      </div>
    </ng-template>

  </mat-card-content>
</mat-card>
